export class InvalidOperationException extends Error {
	constructor(message: string = 'Operation is not valid due to the current state of the object.') {
		super(message);
		this.name = 'InvalidOperationException';
	}
}
